import { render, staticRenderFns } from "./Hauptschirm.vue?vue&type=template&id=0b701bec&scoped=true"
import script from "./Hauptschirm.vue?vue&type=script&lang=ts"
export * from "./Hauptschirm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b701bec",
  null
  
)

export default component.exports